import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Button } from '../../../components/Buttons';
import { Plus } from '../../../components/Icon';
import { resizeAndRotate } from '../../../utils/image';
import { addDocument } from '../../Documents/actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_ADD_DOCUMENT, REQUEST_DELETE_DOCUMENT, REQUEST_VEHICLE_DOCUMENTS } from '../../Users/constants';
import { Loader } from '../../../components/Loader';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ImageCarouselComponent from '../../../containers/App/Components/Carousel/Carousel';

import { deleteDocument } from '../../Documents/actions';
import { isMobileDevice } from '../../../utils/checkDevice';
import {clientId} from "../../../env";
import {AppClientId} from "../../Shared/constants";

const Container = styled.div`
  font-size: 14px;
  margin: 10px auto;
  width: 100%;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const Subtitle = styled.h3`
  width: 100%;
  background: #d9d9d9;
  font-weight: bold;
  padding: 4px;
  font-size: 14px;
`;

const HooiInstallCard = styled.div`
  display: flex;
  border: 1px solid #d9d9d9;
  @media (max-width: 768px) {
    min-width: 250px;
    width: 100%;
  }
`;

const HooiInstallImage = styled.img`
  width: 150px;
  height: 150px;

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
  }
`;

const HooiInstallContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

const STATE = {
  showImagesModal: false,
  group: null,
  comment: '',
  showCarousel: false,
  carouselImages: [],
};

/* eslint-disable react/prefer-stateless-function */
class VehicleHooiInstallationPhotoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  capture(name, callback) {
    //remove existing image upload
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';
    // input.setAttribute('capture', 'camera');

    document.body.appendChild(input);

    input.click();

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          this.props.imageUpload(
            {
              name,
              type: 'photo_hooi_' + name,
              originalFilename: 'originalFilename',
              file,
            },
            'upload_' + name,
          );

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  openCarousel = (images, current) => {
    if (current) {
      let currentIndex = images.map(image => image?.id).indexOf(current[0]?.id);
      const firstPart = images?.slice(currentIndex);
      const secondPart = images?.slice(0, currentIndex);

      this.setState({ showCarousel: true, carouselImages: [...firstPart, ...secondPart] ?? [] });

      return;
    }
    this.setState({ showCarousel: true, carouselImages: images ?? [] });
  };

  closeCarousel = () => {
    this.setState({ showCarousel: false, carouselImages: [] });
  };

  addHooiInstalationImage(index, isNewGroup = false) {
    this.capture('hooi_instalation_' + index);
  }

  handlePhotoDelete = documentId => {
    if (confirm()) {
      this.props.deleteDocument(documentId, this.setStateFn({ showCarousel: false }));
    }
  };

  cleanPhotoName(str) {
    const prefix = 'photo_hooi_hooi_instalation_HOOI_NEW_';
    return str.slice(prefix.length);
  }

  createDynamicInput(name, callback) {
    // Verwijder eventueel oude input
    document.getElementById('temp-upload')?.remove();

    // Maak nieuw input element aan
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.id = 'temp-upload';

    // Tip: laat capture weg op iOS zodat gebruiker mag kiezen
    if (/Android/i.test(navigator.userAgent)) {
      input.setAttribute('capture', 'environment');
    }

    // Luister op change direct, zonder extra lagen
    input.addEventListener('change', evt => {
      const file = evt.target.files[0];
      if (!file) return;
      callback(file);
      input.remove(); // opruimen
    });

    // Voeg toe aan DOM en klik meteen (in dezelfde stack!)
    document.body.appendChild(input);
    input.click(); // <-- werkt zolang dit in de directe onClick zit
  };

  handleCapturedFile(file, name) {
    resizeAndRotate(file).then(resizedFile => {
      this.props.imageUpload(
        {
          name,
          type: `photo_hooi_${name}`,
          originalFilename: file.name,
          file: resizedFile,
        },
        `upload_${name}`,
      );
    });
  };

  renderHooiInstall = () => {
    const separatePhotos = this.vehicle.documents?.filter(
      d => d?.type?.startsWith('photo_hooi_hooi_instalation') || d?.type?.startsWith('HOOI_inslag_done_image'),
    );

    if (!separatePhotos?.length) return <Subtitle>{this.lbl('vehicle.details.hooi_installation.no_photos')}</Subtitle>;

    if (this.props.work) return <Loader small />;
    return (
      <>
        <HooiInstallContainer>
          {separatePhotos?.map(photo => (
            <HooiInstallCard key={`hooi_instalations_${photo.id}`}>
              <VBox>
                <HooiInstallImage src={photo.url} width={150} onClick={() => this.openCarousel(separatePhotos, [photo])} />
                {photo?.type?.includes('HOOI_NEW') &&   <strong>{this.lbl(`vehicle.details.${this.cleanPhotoName(photo?.type)}`)}</strong>}

              </VBox>
            </HooiInstallCard>
          ))}
        </HooiInstallContainer>
      </>
    );
  };

  renderPhotoCarousel = () => {
    return (
      <ModalComponent size="xl" onClose={this.closeCarousel} title={this.lbl('vehicle.details.hooi_installation')}>
        <ImageCarouselComponent imgURLs={this.state.carouselImages} fullSize onDeleteImg={this.handlePhotoDelete} />
      </ModalComponent>
    );
  };

  render() {
    const index = this.vehicle.documents?.filter(d => d?.type?.startsWith('photo_hooi_hooi_instalation'))?.length || 0;
    return (
      <Card className="vehicle-info-card info-card data wide" style={{ width: '100%' }}>
        <Container>
          <HBox vCenter>
            <h2>{this.lbl('vehicle.details.hooi_installation')}</h2>
            <Button
              small
              onClick={() => {
                this.createDynamicInput('hooi_instalation_' + index, file => {
                  this.handleCapturedFile(file, 'hooi_instalation_' + index);
                });
              }}
            >
              <Plus /> {this.lbl('add')}
            </Button>
          </HBox>
          <HBox flip={window.innerWidth <= 768} gap="10px"></HBox>
          <HBox flip={window.innerWidth <= 768} gap="10px"></HBox>
          <VBox>
            {this.renderHooiInstall()}
            {this.state.showCarousel && this.renderPhotoCarousel()}
          </VBox>
        </Container>
      </Card>
    );
  }
}

VehicleHooiInstallationPhotoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_ADD_DOCUMENT, REQUEST_DELETE_DOCUMENT, `${REQUEST_VEHICLE_DOCUMENTS}-${ownProps.vehicle.id}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    imageUpload(documentDto, work, callback) {
      dispatch(addDocument(ownProps.vehicle.id, 'vehicle', documentDto, callback, work));
    },

    deleteDocument(id, callback) {
      dispatch(deleteDocument(ownProps.vehicle?.id, 'vehicle', id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleHooiInstallationPhotoCard = compose(withConnect, withRouter)(VehicleHooiInstallationPhotoCardComp);
